/**
 * Should not be called directly.
 * @see {@link selectAll}
 *
 * @param {NodeList} selectors
 * @private
 */
export function initSelectAll(selectors) {
    // init select all checkboxes
    selectors.forEach((selector) => {
        let targets = selector.getAttribute('name'),
            itemClick = false;

        // trigger change events on targets of the select all element
        selector.addEventListener(
            'change',
            () => {
                if (!itemClick) {
                    // trigger click events on the input fields which need it
                    document.querySelectorAll(`input[name="${targets}"]`).forEach((checkbox) => {
                        if (checkbox.checked !== selector.checked) {
                            checkbox.click();
                        }
                    });
                }
            },
            { passive: true },
        );

        // listen for change events on the targets to de/activate the select all element
        document.querySelectorAll(`input[name="${targets}"]`).forEach((checkbox, index, inputs) => {
            checkbox.addEventListener(
                'change',
                () => {
                    itemClick = true;

                    let checked = Array.prototype.slice.call(inputs).filter((input) => input.checked);

                    // check if all targets are selected
                    if (checked.length === inputs.length - 1 && !selector.checked) {
                        selector.click();
                    } else if (checked.length === 1 && selector.checked) {
                        selector.click();
                    }

                    itemClick = false;
                },
                { passive: true },
            );
        });
    });
}
